module.exports = __webpack_public_path__ + "static/media/crsp.fb812a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/crsp.png
// module id = 424
// module chunks = 0